import { THEME_NAME, THEME_MODE } from 'foundations-theming-base/symbol';
import type {
  ThemeName,
  ThemeMode,
  Theme,
} from 'foundations-theming-base/types';
import { THEME_DATA_TAG } from './getLocalThemeSettings';

type ThemeWithMetadata = Theme & {
  [THEME_NAME]: ThemeName;
  [THEME_MODE]: ThemeMode;
};

export function getThemeMetadata(theme: Theme): ThemeWithMetadata | undefined {
  return THEME_NAME in theme && THEME_MODE in theme
    ? (theme as ThemeWithMetadata)
    : undefined;
}

export const isCanvasTheme = (themeObject: Theme): boolean => {
  return getThemeMetadata(themeObject)?.[THEME_NAME] === 'canvas';
};
export const isTrellisTheme = (themeObject: Theme): boolean => {
  return getThemeMetadata(themeObject)?.[THEME_NAME] === 'trellis';
};
export const isLightTheme = (themeObject: Theme): boolean => {
  return getThemeMetadata(themeObject)?.[THEME_MODE] === 'light';
};
export const isDarkTheme = (themeObject: Theme): boolean => {
  return getThemeMetadata(themeObject)?.[THEME_MODE] === 'dark';
};

export const hasThemeDataAttribute = (): boolean => {
  return document.documentElement.dataset[THEME_DATA_TAG] !== undefined;
};
